import * as React from 'react';
import { Blocks } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { RequirePermission } from '@klareospace/pharos-lib-front-utils';
import { ActionBar, ActionBarSpacer, Button, SearchInput } from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ShippersActionBarProps {
  onBrowseCatalog: () => void;
  onSearchChange: (value: string) => void;
  searchValue: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function ShippersActionBar({
  onBrowseCatalog,
  onSearchChange,
  searchValue,
}: ShippersActionBarProps): React.JSX.Element {
  const { t } = useTranslation('settings');

  return (
    <ActionBar>
      <SearchInput
        ariaLabel={t('shippers.search.ariaLabel')}
        onChange={onSearchChange}
        placeholder={t('shippers.search.placeholder')}
        value={searchValue}
      />
      <ActionBarSpacer />
      <RequirePermission permission="shippers:manage">
        <Button
          className="h-9 gap-1.5 rounded-md px-3 text-sm shadow-sm hover:shadow-md"
          onClick={onBrowseCatalog}
          variant="default"
        >
          <Blocks className="h-4 w-4" />
          {t('shippers.actions.browseCatalog')}
        </Button>
      </RequirePermission>
    </ActionBar>
  );
}
